<template>
  <div>

    

  <div class="flex-row" style="min-height: calc(100vh - 474.22px); display: flex;">
    <div class="chat-sidebar"
      style="flex: 0 0 25%; background: rgb(230, 237, 242); padding-top: 50px; padding-right: 22px; height: calc(-70px + 100vh); overflow-y: auto;">
      <!--
       <h1>Sidebar</h1>
      -->

      <div class="new-chat" style="" @click="newChat()" title="Use this to switch the context of your conversation">
        <span>
          <svg style="width: 18px; height: 18px;" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
          </svg>
        </span>
        <span style="margin-left: 5px; font-size: 14px;">New Chat</span>
      </div>

      <div
        style="flex: 1 1 0%; width: 100%; justify-content: left;
    align-items: center; text-align: left; background-color: #f2f6f9; padding: 6px 12px; margin: 0px; border-radius: 8px; margin-bottom: 10px;">
        <svg style="width: 18px; height: 18px;" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>

        <span style="margin-left: 5px; font-size: 14px; margin-bottom: 20px;">Chat History</span>
        <div v-if="messagesByConversation?.length" style="margin-top: 10px;">
          <div v-for="(chats, i) in messagesByConversation" :key="i">
            <div class="history-chat" style="margin-bottom: 10px;"
              @click="setChats(chats.messages, chats.conversation_id)">
              <p style="font-size: 10px; margin-bottom: 0; opacity: 80%;">{{ $moment(chats.latestTimestamp).fromNow() }}
              </p>
              <p style="font-size: 14px; margin-bottom: 0;">{{ truncatedContent(chats.messages[0].content) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chat-content" ref="scrollableContainer"
      style="flex: 1; padding: 40px 20px 0 20px; height: calc(100vh - 70px); overflow-y: auto; display: flex; flex-direction: column;">
      <span id="top"></span>
      <!-- Scrollable content -->
      <div style="flex: 1;">
        <!-- Simulate content for scrolling; adjust height or content as needed -->
        <div style="min-height: 500px">
          <chat-disclaimer v-if="!isCompetitiveMode" @select-prompt="handlePromptSelected" />
          <intel-disclaimer v-else="!isCompetitiveMode" @select-prompt="handlePromptSelected" />
          <!-- Add more content here to test scrolling -->
          <ul class="mt-16 space-y-5 min-h-[600px]" style="list-style: none; margin: 0; padding: 0;">

            <li v-for="(message, index) in messages.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))" :key="message.timestamp + '-' + message.role"
              style="padding: 20px 0;">

              <div v-if="message.role == 'user'" class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="user-question" style="">
                  <div class="max-w-2xl flex gap-x-2 sm:gap-x-4">
                    <div class="grow space-y-3">
                      <p class="text-neutral-200 long-text" style="margin-bottom: 0;">
                        {{ message.content }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
                 <div v-else-if="role === 'tip'" class="assistant max-w-4xl px-4 sm:px-6 lg:px-8 mx-auto">
                <div style="display:flex; column-gap: 1rem; max-width: 42rem;">



                  <!-- Response + Copy Button -->
                  <div class="flex-1 relative min-h-20">



                    <!-- Actual message content (with right padding so text doesn't go under button) -->
                    <div class="assistant-response pr-14">
                      <div class="d-flex align-items-start mb-3"
                        style="padding: 10px; border-top-right-radius: 14px; border-top-left-radius: 14px; background: rgb(243 246 249 / 80%); border-bottom-right-radius: 4px; border-bottom-left-radius: 4px;">
                        <!-- Left side: Brand / Product badge (replaces robot avatar) -->
                        <div class="d-flex align-items-center mr-2">
                          <div
                            class="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                            style="width: 35px; height: 35px; font-size: 18px; font-weight: bold;">
                            <svg style="height: 38px; width: 38px;" class="shrink-0 size-[38px] rounded-full"
                              width="38px" height="38px" viewBox="0 0 38 38" version="1.1"
                              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <g id="Custom-Preset-15" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <circle id="Oval" fill="#00B4B4" cx="19" cy="19" r="19"></circle>
                                <g id="Group" transform="translate(10.000000, 4.000000)" fill="#FFFFFF"
                                  fill-rule="nonzero">
                                  <path
                                    d="M2.16100057,7.47620841 C2.16100057,7.47620841 1.84443676,9.58259622 3.73409787,11.0583002 C5.62053388,12.5340042 7.78150791,11.6731659 9.04453805,11.0235661 C10.3075682,10.3740323 13.1436624,8.66817385 14.0804004,9.95781653 C15.0139531,11.2474592 13.1500994,12.6190928 13.1500994,12.6190928 C13.1500994,12.6190928 10.8889483,14.7790646 8.87007757,12.7294904 L6.18258329,14.9398828 C6.18258329,14.9398828 7.20331311,16.1601232 8.69568346,16.5889935 L17.4430614,9.60467576 C17.4430614,9.60467576 17.4042408,8.24879447 15.9313139,6.84875411 C14.4583207,5.45188397 12.1067872,5.80819497 10.2687476,6.7730905 C8.43077428,7.73793331 6.64774708,8.55461253 5.87248958,8.27397173 C5.09401363,7.99339684 4.89050737,6.50505152 6.45714785,5.52125326 C8.02378832,4.53745501 9.33851291,4.79286582 10.1137306,5.48026442 L12.6623533,3.47482952 C12.6623533,3.47482952 11.2313659,1.79101768 9.20280668,1.87930946 L11.570532,0 L19,8.57985571 L19,19.6980559 L7.1419301,29 L0,20.6282305 L0,9.20104864 L2.16100057,7.47311068 L2.16100057,7.47620841 Z"
                                    id="Path"></path>
                                </g>
                              </g>
                            </svg>
                          </div>bv 
                        </div>

                        <!-- Center: Source name + optional tag -->
                        <div class="flex-grow-1">
                          <div class="font-weight-bold text-dark">Sales & Marketing Agent</div>
                          <small class="text-muted">Powered by Spacesaver documentation</small>
                        </div>

                        <!-- Right side: Copy button (only appears on hover – clean!) -->
                        <div class="ml-auto opacity-0 hover-opacity-100 transition-opacity"
                          style="transition: opacity 0.2s;">
                          <button @click="copyToClipboard(getPlainText(message.content))"
                            class="btn btn-sm btn-outline-secondary py-1 px-2" style="border-radius: 8px; border: none;"
                            title="Copy to clipboard">
                            <i class="far fa-copy mr-1"></i> Copy
                          </button>
                        </div>
                      </div>
                      <markdown-it :source="message.content" style="line-height: 2.2;" />

                      <!-- References -->
                      <span class="mt-[20px] block" v-if="message.docs">
                        <p class="text-xl font-bold mb-3">References:</p>
                        <ul class="list-disc list-inside space-y-1">
                          <li v-for="(ref, index) in getUniqueRefs(message.docs)" :key="index">
                            <a :href="ref.includes('/Marketing Docs/Install') ? `/service-and-installation?search=${formatSearch(decodeHtmlEntities(ref.split('/').pop().replace('.pdf', '')))}`
                              : ref.includes('/Marketing Docs/Products') ? `/marketing-materials?search=${formatSearch(decodeHtmlEntities(ref.split('/').pop().replace('.pdf', '')))}`
                                : ref.includes('/Marketing Docs/Sales') ? `/sales-and-training?search=${formatSearch(decodeHtmlEntities(ref.split('/').pop().replace('.pdf', '')))}`
                                  : '#'" target="_blank" class="text-[#00b4b4] hover:underline">
                              {{ decodeHtmlEntities(ref.split('/').pop().replace('.pdf', '')) }}
                            </a>
                          </li>
                        </ul>
                      </span>

                      <!-- Web Articles -->
                      <span class="mt-[20px] block" v-if="message.articles">
                        <p class="text-xl font-bold mb-4">Web Results:</p>
                        <ul class="space-y-4">
                          <li v-for="(article, i) in parseArticles(message.articles)" :key="i"
                            class="bg-[#303030] rounded-xl p-4 hover:bg-[#383838] transition">
                            <a :href="article.url" target="_blank" class="block text-white">
                              <p class="text-sm text-gray-400 mb-1">{{ formatSourceAndDate(article.url, article.date) }}
                              </p>
                              <h4 class="text-lg font-bold line-clamp-1">{{ article.title }}</h4>
                              <p class="text-gray-300 line-clamp-2 mt-1">{{ article.snippet }}</p>
                            </a>
                          </li>
                        </ul>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="assistant max-w-4xl px-4 sm:px-6 lg:px-8 mx-auto">
                <div style="display:flex; column-gap: 1rem; max-width: 42rem;">



                  <!-- Response + Copy Button -->
                  <div class="flex-1 relative min-h-20">



                    <!-- Actual message content (with right padding so text doesn't go under button) -->
                    <div class="assistant-response pr-14">
                      <div class="d-flex align-items-start mb-3"
                        style="padding: 10px; border-top-right-radius: 14px; border-top-left-radius: 14px; background: rgb(243 246 249 / 80%); border-bottom-right-radius: 4px; border-bottom-left-radius: 4px;">
                        <!-- Left side: Brand / Product badge (replaces robot avatar) -->
                        <div class="d-flex align-items-center mr-2">
                          <div
                            class="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                            style="width: 35px; height: 35px; font-size: 18px; font-weight: bold;">
                            <svg style="height: 38px; width: 38px;" class="shrink-0 size-[38px] rounded-full"
                              width="38px" height="38px" viewBox="0 0 38 38" version="1.1"
                              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <g id="Custom-Preset-15" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <circle id="Oval" fill="#00B4B4" cx="19" cy="19" r="19"></circle>
                                <g id="Group" transform="translate(10.000000, 4.000000)" fill="#FFFFFF"
                                  fill-rule="nonzero">
                                  <path
                                    d="M2.16100057,7.47620841 C2.16100057,7.47620841 1.84443676,9.58259622 3.73409787,11.0583002 C5.62053388,12.5340042 7.78150791,11.6731659 9.04453805,11.0235661 C10.3075682,10.3740323 13.1436624,8.66817385 14.0804004,9.95781653 C15.0139531,11.2474592 13.1500994,12.6190928 13.1500994,12.6190928 C13.1500994,12.6190928 10.8889483,14.7790646 8.87007757,12.7294904 L6.18258329,14.9398828 C6.18258329,14.9398828 7.20331311,16.1601232 8.69568346,16.5889935 L17.4430614,9.60467576 C17.4430614,9.60467576 17.4042408,8.24879447 15.9313139,6.84875411 C14.4583207,5.45188397 12.1067872,5.80819497 10.2687476,6.7730905 C8.43077428,7.73793331 6.64774708,8.55461253 5.87248958,8.27397173 C5.09401363,7.99339684 4.89050737,6.50505152 6.45714785,5.52125326 C8.02378832,4.53745501 9.33851291,4.79286582 10.1137306,5.48026442 L12.6623533,3.47482952 C12.6623533,3.47482952 11.2313659,1.79101768 9.20280668,1.87930946 L11.570532,0 L19,8.57985571 L19,19.6980559 L7.1419301,29 L0,20.6282305 L0,9.20104864 L2.16100057,7.47311068 L2.16100057,7.47620841 Z"
                                    id="Path"></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>

                        <!-- Center: Source name + optional tag -->
                        <div class="flex-grow-1">
                          <div class="font-weight-bold text-dark">Sales & Marketing Agent</div>
                          <small class="text-muted">Powered by Spacesaver documentation</small>
                        </div>

                        <!-- Right side: Copy button (only appears on hover – clean!) -->
                        <div class="ml-auto opacity-0 hover-opacity-100 transition-opacity"
                          style="transition: opacity 0.2s;">
                          <button @click="copyToClipboard(getPlainText(message.content))"
                            class="btn btn-sm btn-outline-secondary py-1 px-2" style="border-radius: 8px; border: none;"
                            title="Copy to clipboard">
                            <i class="far fa-copy mr-1"></i> Copy
                          </button>
                        </div>
                      </div>
                      <markdown-it :source="message.content" style="line-height: 2.2;" />

                      <!-- References -->
                      <span class="mt-[20px] block" v-if="message.docs">
                        <p class="text-xl font-bold mb-3">References:</p>
                        <ul class="list-disc list-inside space-y-1">
                          <li v-for="(ref, index) in getUniqueRefs(message.docs)" :key="index">
                            <a
                              :href="
                                ref.includes('/Marketing Docs/Install')
                                  ? `/service-and-installation?search=${formatSearch(decodeHtmlEntities(cleanFilename(ref)))}`
                                  : ref.includes('/Marketing Docs/Products')
                                    ? `/marketing-materials?search=${formatSearch(decodeHtmlEntities(cleanFilename(ref)))}`
                                    : ref.includes('/Marketing Docs/Sales')
                                      ? `/sales-and-training?search=${formatSearch(decodeHtmlEntities(cleanFilename(ref)))}`
                                      : '#'
                              "
                              target="_blank"
                              class="text-[#00b4b4] hover:underline"
                            >
                              {{ decodeHtmlEntities(cleanFilename(ref)) }}
                            </a>
                          </li>
                        </ul>
                      </span>

                      <!-- Web Articles -->
                      <span class="mt-[20px] block" v-if="message.articles">
                        <p class="text-xl font-bold mb-4">Web Results:</p>
                        <ul class="space-y-4">
                          <li v-for="(article, i) in parseArticles(message.articles)" :key="i"
                            class="bg-[#303030] rounded-xl p-4 hover:bg-[#383838] transition">
                            <a :href="article.url" target="_blank" class="block text-white">
                              <p class="text-sm text-gray-400 mb-1">{{ formatSourceAndDate(article.url, article.date) }}
                              </p>
                              <h4 class="text-lg font-bold line-clamp-1">{{ article.title }}</h4>
                              <p class="text-gray-300 line-clamp-2 mt-1">{{ article.snippet }}</p>
                            </a>
                          </li>
                        </ul>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li v-if="isLoading" class="max-w-4xl py-2 px-4 sm:px-6 lg:px-8 mx-auto flex gap-x-2 sm:gap-x-4 text-center">
               <div class="prompt-tip-container" style="margin-bottom: 20px;">
                <transition name="fadetip">
                  <small v-if="weakPromptWarning" class="prompt-tip-content">
                    <p 
                      v-html="weakPromptWarning" 
                      class="prompt-tip-text"
                      style="margin-bottom: 0;"
                    ></p>
                  </small>
                </transition>
              </div>
              <div ref="spinner" class="ml-auto mr-auto">
                <div class="text-white ml-auto mr-auto">
                  <atom-spinner id="spinner" :animation-duration="1000" :size="60" :color="'#a3a3a3'" />
                </div>
              </div>
            </li>

            <li id="bottom"></li>
          </ul>
        </div>
      </div>

      <!-- Sticky input at the bottom -->
      <div class="coolInstall-header align-items-center rounded bs-shadow" style="
        padding: 20px; 
        position: sticky; 
        bottom: 0; 
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(12px);
        z-index: 10; 
        border-bottom: 40px solid rgb(241 246 249);
        border-radius: 24px 24px 0 0!important; 
        box-shadow: 
  0 -25px 50px -20px rgba(0, 0, 0, 0.04), 0 -50px 100px -40px rgba(0, 0, 0, 0.03);">
        <div class="question-header d-flex align-items-center rounded w-100">

          <div class="w100" style="position: relative;">
            <form class="w100" style="margin-bottom: 0;" @submit.prevent>
              <div class="form-group mb-0" style="position: relative;">
                <input type="text"
                  style="padding: 15px; padding-right: 48px; width: 100%; border-radius: 14px; border: none; background: #e6edf2;"
                  :placeholder="`How can I help, ${firstName}?`" v-model="userMessage"
                  @keyup.enter="sendProductMessage" />
                <button @click.prevent="sendProductMessage" type="button" class="icon-button"
                  style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);">
                  <svg class="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" viewBox="0 0 16 16">
                    <path
                      d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z">
                    </path>
                  </svg>
                </button>
              </div>
            </form>
            <!--
             <div class="prompt-tip-container">
              <transition name="fadetip">
                <small v-if="weakPromptWarning" class="prompt-tip-content">
                  <p 
                    v-html="weakPromptWarning" 
                    class="prompt-tip-text"
                    style="margin-bottom: 0;"
                  ></p>
                </small>
              </transition>
            </div>
            -->
           
          </div>

        </div>
        <!--  Put this just before the sticky input bar  -->
        <div class="toggle-wrapper" style=" opacity: 1;padding: 10px 0px 0px; display: flex; align-items: center; gap: 12px;">
          <label class="toggle-label" for="mode-toggle" style="margin-bottom: 0;">
            <span style="font-weight:500; font-size:14px;">SSC data</span>
          </label>

          <input type="checkbox" id="mode-toggle" v-model="isCompetitiveMode" class="sr-only" />
          <div class="toggle-switch" :class="{ 'checked': isCompetitiveMode }"
            @click="toggleCompetitiveMode">
            <div class="toggle-knob"></div>
          </div>

          <label class="toggle-label" for="mode-toggle" style="margin-bottom: 0;">
            <span style="font-weight:500; font-size:14px;">Competitive intel</span>
          </label>
        </div>
      </div>
    </div>
  </div>
    </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import Avatar from '../components/Atoms/Avatar.vue'
import MultipleUploadAWS from "../components/Organisms/MultipleUploadAWS.vue";
import MultipleUpload from "../components/Organisms/MultipleUpload.vue";
import Likes from "../components/Organisms/Likes.vue";
import InstallCard from "../components/Organisms/InstallCard.vue";
import etoTour from "../components/Tours/etoTour.vue";
import ChatDisclaimer from "@/components/chat/ChatDisclaimer.vue";
import IntelDisclaimer from "@/components/chat/IntelDisclaimer.vue";
import { jwtDecode } from "jwt-decode";
import MarkdownIt from "vue3-markdown-it";


const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
  },
};

export default {
  name: "ProductChatIntel",
  components: {
    ChatDisclaimer,
    IntelDisclaimer,
    AtomSpinner,
    Avatar,
    // VLazyImage,
    MultipleUploadAWS,
    MultipleUpload,
    Likes,
    InstallCard,
    etoTour,
    MarkdownIt,
  },
  data() {
    return {
      // server: 'http://localhost:5002',
      server: import.meta.env.VITE_APP_SERVER_URL,
      API: "https://knowledgebaseapi.spacesaver.com",
      isCompetitiveMode: false,
      searchQuery: "",
      userMessage: "",
      response: "",
      isLoading: false,
      loading: true,
      allMessages: [],
      messages: [],
      conversations: {},
      currentUsername: null,
      currentConversationId: null,
      weakPromptWarning: '',
      weakPromptCount: 0,
      UserId: "",
      SessionId: "",
      enabled: true,
      webAccess: false,
      fullName:
        this.$store.state.user.FirstName +
        " " +
        this.$store.state.user.LastName,
      UserFirstName: this.$store.state.user.FirstName,
      lightbox: false,
    };
  },
  filters: {
    truncate: function (value) {
      if (value.length > 200) {
        value = value.substring(0, 200) + "...";
      }
      return value;
    },
    truncateTitle: function (value) {
      if (value.length > 50) {
        value = value.substring(0, 50) + "...";
      }
      return value;
    },
  },
  methods: {
    firstLoad: function () {

      this.loading = true;
      const token = localStorage.getItem("SSCUSER");
      const decoded = jwtDecode(token);
      console.log(decoded)
      this.SessionId = decoded.UserName;
      // alert(decoded.UserId);
      this.getAllChats(decoded.UserName)
      this.startNewConversation();

    },
    handlePromptSelected(prompt) {
      this.userMessage = prompt;  
      this.sendProductMessage();       
    },
    cleanFilename(ref) {
      const filename = ref.split('/').pop();          
      // Remove .pdf, .doc, .docx (case-insensitive) from the end
      return filename.replace(/\.(pdf|doc|docx)$/i, '');
    },
    async getAllChats(id) {
      try {
        // console.log(`https://spacenet3api.spacesaver.com/api/v1/chat?session_id=${id}`)
        // const response = await axios.get(`http://127.0.0.1:8001/get-all-chats?session_id=${id}`);
        // const response = await axios.get(`https://spacenet3api.spacesaver.com/api/v1/chat?session_id=${id}`, auth);
        const response = await axios.get(`${this.server}/api/v1/chat?session_id=${id}`, auth);
        this.allMessages = response.data; // Store the complete response
        // this.messages.push({role: "system", data: response.data.assistant_message})
        // this.scrollToBottom();
        // this.scrollToTextarea();
      } catch (error) {
        if (error.response.status === 401) {
          this.$router.push("/");
        }

        console.error("Error fetching responses:", error);
        this.response = "Error fetching response. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    async getAllNewChats(id) {
      try {
        const response = await axios.get(`${this.server}/api/v1/chat?session_id=${id}`, auth);
        this.allMessages = response.data; // Always update full history (for sidebar)

        if (!this.currentConversationId) {
          console.log("No current conversation — starting new");
          this.startNewConversation();
          this.messages = [];
          return;
        }

        // Find the current conversation in the fresh data
        const matchedConversation = this.messagesByConversation.find(
          conv => conv.conversation_id === this.currentConversationId
        );

        if (!matchedConversation) {
          console.log("Current conversation no longer exists — starting new");
          this.startNewConversation();
          this.messages = [];
          return;
        }

        // === KEY FIX: Only update this.messages if there are NEW messages ===
        const currentLength = this.messages.length;
        const serverLength = matchedConversation.messages.length;

        if (serverLength > currentLength) {
          // Only now do we replace the array — this adds the assistant response
          this.messages = [...matchedConversation.messages]; // already sorted oldest → newest
          this.$nextTick(() => this.scrollToBottom());
        }
        // If serverLength === currentLength → assistant still generating → do NOTHING
        // No re-render, no flicker, spinner stays visible

      } catch (error) {
        if (error.response?.status === 401) {
          this.$router.push("/");
        }
        console.error("Error fetching responses:", error);
      } finally {
        this.loading = false;
      }
    },

    getRandomPromptTip() {
      const word = this.userMessage.trim() || 'that word';
      const tips = [
        `One-word prompts are an art form! To get the best results, try adding a bit more detail.`,

        `Pro tip: The more context you give, the better I can tailor the answer.Try expanding on “${word}”!`,

        `With just ‘${word}’, I could guess what you are looking for… but with a fuller prompt, magic happens!`,

        `“One word? You’re really testing my mind-reading skills today!” Help me out with a little more detail?`,

        `Great starting point with ‘${word}’! To make my response better, try adding more detail`,

        `One-word prompts are beautifully minimalist! To unlock even more magic, try adding a little direction.`,

        `Bold move with just one word! try adding little more detail to level it up.`,

        `‘${word}’ — short and mysterious. Care to tell me what you'd like to explore about it?`,

        `Love the brevity! A tiny bit more context turns good answers into great ones.`,

        `One word is a strong opener! Now let’s build on it — what would you like to know about ‘${word}’?`,
        
        `Single-word energy detected! Add just a little more detail in your prompt and watch the response level up.`,
        
        `You went full minimalist with ‘${word}’ — respect! Care to add a hint about what you're after?`,
        
        `Ah, the classic one-word prompt. I see you’re an artist of brevity. Let’s collaborate — what should we create with ‘${word}’?`,
        
        `‘${word}’ is intriguing all by itself! But if you add a bit more direction, I could respond better for you.`,
        
        `One-word prompts are bold and beautiful. Two or three more words? Now we’re talking masterpiece territory.`,
        
        `Zen and the art of one-word prompting… To reach prompt enlightenment, try adding a little more detail to the prompt.`,
      ];

      const randomIndex = Math.floor(Math.random() * tips.length);
      return tips[randomIndex];
    },

    checkMessage() {
      if (this.isSingleWord()) {
        this.weakPromptCount++;

        if ([1, 5, 10].includes(this.weakPromptCount)) {
          const randomMessage = this.getRandomPromptTip();

          // this.messages.push({role: "tip", data: randomMessage});
          this.weakPromptWarning = randomMessage;

          /*
          this.$toast.success(randomMessage, {
            hideProgressBar: false,
            icon: false,
            dangerouslyUseHtmlString: true,
            timeout: 9000,
          });
          */
          
        }
      }

  },

    isSingleWord() {
      const trimmed = this.userMessage.trim();
      return trimmed.length > 0 && trimmed.split(/\s+/).length === 1;
    },

    async sendProductMessage() {
      const token = localStorage.getItem("SSCUSER");
      // Timestamp when user clicked send
      const userTimestamp = new Date().toISOString();

      if (!this.isTokenValid(token)) {
        this.$toast.error("Session expired. Please log in again.");
        this.$router.push("/");
        return;
      }

      if (this.loading == true) {
        return;
      }

      this.checkMessage();

      const userMessage = this.userMessage.trim();
      if (!userMessage) return;

      this.userMessage = "";
      this.isLoading = true;

      this.messages.push({
        role: "user",
        content: userMessage,
        timestamp: userTimestamp,
        conversation_id: this.currentConversationId
      });

      this.$nextTick(() => this.scrollToBottom());

      // Add user message immediately (keeps order perfect)
      
      /*
      this.messages.push({
        role: "user",
        content: userMessage,
        timestamp: userTimestamp,
        conversation_id: this.currentConversationId
      });
      */
    
      // this.scrollToBottom();

      try {
        const baseURL = `${this.server}/api/v1`;
        const endpoint = this.isCompetitiveMode ? `${baseURL}/competitive` : `${baseURL}/chat`;

        const payload = this.isCompetitiveMode
          ? { session_id: this.SessionId, question: userMessage, history: this.conversationHistory, conversationID: this.currentConversationId, companyID: String(this.CompanyID) }
          : { session_id: this.SessionId, question: userMessage, history: this.conversationHistory, conversationID: this.currentConversationId, companyID: String(this.CompanyID)};

        // console.log("Payload:", payload);
        // console.log("Endpoint:", endpoint);

        const response = await axios.post(endpoint, payload, auth);

        // const assistantTimestamp = new Date().toISOString();

        // Add assistant message (order stays correct)
        /*
        this.messages.push({
          role: "assistant", // better than "system"
          content: response.data.answer || "",
          docs: response.data.references_csv || null,
          articles: response.data.articles || null,
          timestamp: assistantTimestamp,
          conversation_id: this.currentConversationId
        });
        */

        // Only refresh sidebar — NEVER touch this.messages
        await this.getAllNewChats(this.SessionId);
        this.weakPromptWarning = '';

        // this.$nextTick(() => this.scrollToBottom());
      } catch (error) {
        console.error("Send message error:", error);
        this.messages.push({
          role: "assistant",
          content: "Sorry, I couldn't respond. Please try again.",
          timestamp: new Date().toISOString()
        });
      } finally {
        this.isLoading = false;
      }
    },

    generateConversationId() {
      this.currentConversationId = 'conv_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
      // return 'conv_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    },

    startNewConversation() {
      this.currentConversationId = 'conv_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
      /*
      this.addConversation({
        title: this.generateConversationId(),
        messages: []
      });   
      */
    },

    isTokenValid(token) {

      if (!token) return false;

      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Convert to seconds
        return decoded.exp > currentTime; // Check if the token is still valid
      } catch (error) {
        return false; // Invalid token
      }
    },

    formatTime(timestamp) {
      return new Date(timestamp).toLocaleTimeString();
    },

    handleEnter(event) {

      event.preventDefault();

      if (this.enabled) {
        this.sendProductMessage();
        // alert("product");
      } else if (this.webAccess) {
        this.sendWebMessage();
        // alert("web");
      } else {
        this.sendMessage();
        // alert("general");
      }
    },
    scrollToSpinner() {
      const container = this.$refs.scrollableContainer;
      const spinner = this.$refs.spinner;

      if (container && spinner) {
        // Ensure the spinner is visible (e.g., isLoading is true)
        if (this.isLoading) {
          // Scroll the container to the spinner
          container.scrollTo({
            top: spinner.offsetTop - container.offsetTop,
            behavior: 'smooth'
          });
        } else {
          console.warn('Spinner is not visible (isLoading is false)');
        }
      } else {
        console.warn('Scrollable container or spinner ref not found');
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const thebottom = document.getElementById("bottom");
        if (thebottom) {
          thebottom.scrollIntoView({ behavior: "smooth" });
        }
      });
    },
    scrollToTop() {
      this.$nextTick(() => {
        const thebottom = document.getElementById("top");
        if (thebottom) {
          thebottom.scrollIntoView({ behavior: "smooth" });
        }
      });
    },

    handleKeydown(event) {
      if (event.keyCode === 13) {
        this.updateURL();
      }
    },

    getUniqueRefs(docs) {
      if (!docs) {
        console.log('No docs provided');
        return [];
      }
      // Split refs and log raw input
      const refs = docs.split(', ').map(ref => ref.trim());
      console.log('Raw refs:', refs);

      // Deduplicate by filename, keeping the first occurrence
      const seenFilenames = new Set();
      const uniqueRefs = [];
      for (const ref of refs) {
        const filename = ref.split('/').pop();
        if (!seenFilenames.has(filename)) {
          seenFilenames.add(filename);
          uniqueRefs.push(ref);
        }
      }

      console.log('Unique refs:', uniqueRefs);
      return uniqueRefs;
    },

    decodeHtmlEntities(str) {
      // Use a textarea to decode all HTML entities
      const textarea = document.createElement('textarea');
      textarea.innerHTML = str;
      return textarea.value;
    },

    formatSearch(filename) {
      // Remove .pdf extension if present (safety check)
      const cleanFilename = filename.replace('.pdf', '');

      // Split on '] ' to separate category and title
      const parts = cleanFilename.split('] ');

      if (parts.length > 1) {
        // Category: Remove '[' from the start
        const category = parts[0].replace('[', '');

        // Title: Use the rest of the string as-is
        const title = parts[1];

        // Construct the search string with quotes around the title
        const searchString = `${category} "${title}"`;
        // const searchString = `${category} ${title}`;

        // Return URL-encoded string for safety in href
        return encodeURIComponent(searchString);
      }

      // Fallback: If no '] ' split, remove all brackets and encode
      return encodeURIComponent(cleanFilename.replace(/[[\]]/g, ''));
    },

    /*
    setChats(chats, id) {
        // this.messages = chats;
        this.messages = [...chats].sort((a, b) => {
          return new Date(a.timestamp) - new Date(b.timestamp);
        });
        this.currentConversationId = id;

      this.scrollToBottom();
    },
    */
    setChats(chats, id) {
  const sorted = [...(Array.isArray(chats) ? chats : [])].sort((a, b) => {
    const ta = a?.timestamp ? new Date(a.timestamp).getTime() : 0;
    const tb = b?.timestamp ? new Date(b.timestamp).getTime() : 0;
    return ta - tb;
  });

  // Set messages (this should now stick)
  this.messages = sorted;

  // Set conversation ID
  this.currentConversationId = id;

  // Auto-detect mode from loaded history
  // (only sets mode — does NOT clear messages)
  this.isCompetitiveMode = sorted.length > 0 && sorted.some(m => m.intel_question === true);

  // Scroll after render
  this.$nextTick(() => {
    this.scrollToBottom();
  });

  // Debug log so you can see it working
  console.log(
    `Loaded conv ${id}: ${sorted.length} messages | ` +
    `Competitive mode auto-set to: ${this.isCompetitiveMode}`
  );
},

toggleCompetitiveMode() {
    // Flip the mode
    this.isCompetitiveMode = !this.isCompetitiveMode;

    // Mimic old watcher behavior: clear + new conversation
    this.startNewConversation();   // generates new conv ID
    this.messages = [];            // clear chat
    this.scrollToTop();            // optional: reset scroll

    console.log(`Manual toggle → Mode: ${this.isCompetitiveMode}, New conv ID: ${this.currentConversationId}`);
  },

  // Your existing setChats — no changes needed
  setChats(chats, id) {
    const sorted = [...(Array.isArray(chats) ? chats : [])].sort((a, b) => {
      const ta = a?.timestamp ? new Date(a.timestamp).getTime() : 0;
      const tb = b?.timestamp ? new Date(b.timestamp).getTime() : 0;
      return ta - tb;
    });

    this.messages = sorted;
    this.currentConversationId = id;

    // Auto-detect mode from history (no clearing)
    this.isCompetitiveMode = sorted.length > 0 && sorted.some(m => m.intel_question === true);

    this.$nextTick(() => this.scrollToBottom());

    console.log(
      `Loaded conv ${id}: ${sorted.length} msgs | ` +
      `Mode auto-set: ${this.isCompetitiveMode}`
    );
  },

    newChat() {
      this.messages = [];
      this.scrollToTop();
      this.startNewConversation();
    },


    parseArticles(articles) {
      if (!articles) return [];
      // If articles is a string, parse it; if already an array, return as-is
      return typeof articles === 'string' ? JSON.parse(articles) : articles;
    },

    formatSourceAndDate(url, date) {
      try {
        const domain = new URL(url).hostname.replace('www.', ''); // e.g., "cnn.com"
        const dateStr = date || '';
        return `${domain}  ${dateStr}`; // e.g., "cnn.com - 2025-03-05 14:32:05.567"
      } catch (e) {
        console.error(`Error parsing URL ${url}:`, e);
        return `${url}  ${date || ''}`; // Fallback to full URL if parsing fails
      }
    },




    updateURL() {
      const queryParams = [];
      //const page = urlParams.get("page") || "";
      if (this.search.trim().length > 0) {
        queryParams.push(`search=${encodeURIComponent(this.search.trim())}`);
      }
      if (this.selectedProduct) {
        queryParams.push(`product=${encodeURIComponent(this.selectedProduct)}`);
      }
      if (this.selectedMarket) {
        queryParams.push(`market=${encodeURIComponent(this.selectedMarket)}`);
      }
      if (this.ETOproject == "true") {
        queryParams.push(`project=${encodeURIComponent("eto")}`);
      }
      if (this.selectedMaterial) {
        queryParams.push(`material=${encodeURIComponent(this.selectedMaterial)}`);
      }

      const newURL = `${window.location.pathname}?${queryParams.join("&")}`;
      window.history.pushState({}, "", newURL);
      this.firstLoad();
      // window.location.href = newURL;
    },

    resetURL: function () {
      // Get the base URL without query parameters
      const baseURL = this.$route.path;

      // Replace the current history entry with the new base URL
      history.replaceState(null, '', baseURL);
    },


    paginateURL() {
      const url = new URL(window.location.href);
      url.searchParams.set("page", this.currPage);
      window.history.pushState({}, "", url);
      this.firstLoad();
    },


    openLightbox() {
      this.lightbox = true;
    },
    closeLightbox() {
      // console.log("hello");
      this.lightbox = false;
    },

    clearSearch() {
      this.search = "";
      this.selectedProduct = null;
      this.selectedMarket = null;
      this.ETOproject = 'false';
      this.selectedMaterial = null;
      this.currPage = 1;
      this.resetURL();
      this.firstLoad();
    },

    searchReset: function () {
      this.selectedCat = "Show All";
    },

    setPage: function (idx) {
      // console.log("setPage " + idx)
      // this.search = "";
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }

      this.currPage = idx;
      this.paginateURL();
    },


    truncatedContent(text) {
      const maxChars = 30; // Set maximum character limit
      const content = text || '';
      if (content.length > maxChars) {
        return content.substring(0, maxChars - 3) + '...';
      }
      return content;
    },

    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.success("Copied response to clipboard!", {
          position: "top-right",
          timeout: 2000,
          icon: false,
        });
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        this.$toast.success("Copied!", { timeout: 1500 });
      }
    },

    // Helper to get clean text from markdown (strips HTML tags)
    getPlainText(markdownContent) {
      if (!markdownContent) return "";
      const div = document.createElement("div");
      div.innerHTML = markdownContent; // vue3-markdown-it outputs HTML
      return div.textContent || div.innerText || "";
    },

  },

  computed: {
    userHistoryMessages() {
      if (!this.messages?.length) {
        return [];
      }

      return this.messages
        // .filter(message => message.role === 'user') // Filter for user messages
        .sort((a, b) => {
          const dateA = new Date(a.timestamp);
          const dateB = new Date(b.timestamp);
          return dateB - dateA; // Newest first
        })
        .slice(0, 20); // Limit to last 20
    },
    conversationHistory() {
      // Transform userHistoryMessages to exclude articles
      return this.userHistoryMessages.map(({ role, content, timestamp, docs }) => ({
        role,
        content,
        // timestamp,
        // docs
      }));
    },

    messagesByConversation() {
      if (!this.allMessages?.length) {
        return [];
      }

      // Step 1: Group messages by conversation_id
      const grouped = this.allMessages.reduce((acc, message) => {
        const cid = message.conversation_id || 'unknown';

        if (!acc[cid]) {
          acc[cid] = {
            conversation_id: cid,
            messages: [],
            latestTimestamp: message.timestamp || ''
          };
        }

        acc[cid].messages.push(message);

        // Keep track of the most recent message in this conversation
        if (!acc[cid].latestTimestamp || message.timestamp > acc[cid].latestTimestamp) {
          acc[cid].latestTimestamp = message.timestamp;
        }

        return acc;
      }, {});

      // Step 2: Convert to array and sort properly
      return Object.values(grouped)
        .map(group => ({
          conversation_id: group.conversation_id,
          // Sort messages inside each conversation: OLDEST → NEWEST
          messages: group.messages.sort((a, b) =>
            new Date(a.timestamp) - new Date(b.timestamp)
          ),
          latestTimestamp: group.latestTimestamp
        }))
        // Sort conversations: newest activity first
        .sort((a, b) =>
          new Date(b.latestTimestamp) - new Date(a.latestTimestamp)
        );
    },
    messagesByDay() {
      if (this.allMessages?.length) {
        // Group messages by date
        const grouped = this.allMessages.reduce((acc, message) => {

          // Extract date (YYYY-MM-DD) from timestamp
          const date = message.timestamp.split('T')[0];

          // Initialize array for this date if it doesn't exist
          if (!acc[date]) {
            acc[date] = [];
          }

          // Add message to the date's array
          acc[date].push(message);

          return acc;
        }, {});

        // Convert grouped object to array of { date, messages } objects
        const result = Object.keys(grouped).map(date => ({
          date,
          messages: grouped[date]
        }));

        // Sort by date (descending, most recent first)
        return result.sort((a, b) => new Date(b.date) - new Date(a.date));
      }
    },


    activeNav() {
      return this.$store.state.activePage;
    },

    showButton() {
      if (this.search.trim().length > 0) {
        // console.log('true')
        return true;
      } else {
        // console.log('false')
        return false;
      }
    },
    colorGetter() {
      return this.$store.state.colors;
    },
    firstName() {
      return this.$store.state.user.FirstName;
    },
    lastName() {
      return this.$store.state.user.LastName;
    },
    company() {
      return this.$store.state.user.Company;
    },
    USERID() {
      return this.$store.state.user.UserId;
    },
    CompanyID() {
      return this.$store.state.user.CompanyID;
    },
  },
  watch: {
    /*
    isCompetitiveMode(newVal, oldVal) {
      this.startNewConversation();
      this.messages = [];
    }
      */
  },
  
  created() {
    this.$store.commit("showNavigation");
    this.scrollToTop();

    // console.log(this.$route.path);
  },
  mounted() {
    this.firstLoad();
  },
};
</script>


<style>
.flex-row {
  display: flex;
}

.user-question {
  border-radius: .75rem;
  background: #fff;
  max-width: 40%;
  margin-left: auto;
  padding-bottom: .625rem;
  padding-top: .625rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.assistant ul {
  list-style: none;
  /* Remove default bullets */
  margin: 0;
  padding-left: 1.5rem;
  /* Space for bullets */
  margin-bottom: 30px;
}

/* Parent list items with solid discs */
.assistant ul li {
  position: relative;
  margin-bottom: 0;
  line-height: 1.5;
}



/* Nested (child) list styling */
.assistant ul ul {
  padding-left: 2rem;
  /* Indent nested lists */
}

/* Child list items with empty center discs */
.assistant ul ul li:before {
  content: "◦";
  /* Empty circle (Unicode U+25E6) */
  color: #575757;
  /* Slightly lighter color for contrast */
  font-size: 1.2rem;
}

.assistant-response {
  position: relative;
  max-width: 100%;
  flex-grow: 1;
  border-radius: .75rem;
  background: #fff;
  max-width: 80%;
  margin-right: auto;
  padding-bottom: 1rem;
  padding-top: 1rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.single-line {
  white-space: nowrap;
  /* Prevents text from wrapping to the next line */
  overflow: hidden;
  /* Hides any overflow content */
  text-overflow: ellipsis;
  /* Adds an ellipsis (...) for overflowed text */
  display: inline-block;
  /* Ensures the span respects width constraints */
  max-width: 100%;
  /* Limits the span to the parent container's width */
}

.icon-button {
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  color: #ffffff;
  background-color: #00b4b4;
  border: none;
  margin-left: auto;
}

.icon-button:hover {
  background-color: #017070;
}

.icon-button:focus {
  z-index: 10;
  outline: none;
  background-color: #017070;
}

.new-chat {
  flex: 1 1 0%;
  width: 100%;
  justify-content: left;
  align-items: center;
  text-align: left;
  background-color: #f2f6f9;
  padding: 6px 12px;
  margin: 0px;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.new-chat:hover {
  background-color: #fff;
}

.history-chat {
  border-radius: 8px;
  text-align: left;
  /*background-color: #fff; */
  padding: 6px 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.history-chat:hover {
  background-color: #fff;
}

.assistant-response {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  color: #575757;
  /* Dark text for light theme */
  line-height: 1.2 !important;
  max-width: 800px;
  /* Constrain width for readability */
  margin: 0 auto;
  /* Center content */
  padding: 16px;
  /* 1rem = 16px */
}

.assistant-response p {

  line-height: 1.2 !important;
}

/* Headings */
.assistant-response h1 {
  font-size: 22px;
  /* 1.8rem = 28.8px */
  font-weight: 400;
  margin: 24px 0 12px;
  /* 1.5rem = 24px, 0.75rem = 12px */
  color: #575757;
}

.assistant-response h2 {
  font-size: 20px;
  /* 1.5rem = 24px */
  font-weight: 400;
  margin: 20px 0 8px;
  /* 1.25rem = 20px, 0.5rem = 8px */
  color: #575757;
}

.assistant-response strong {
  font-weight: bold !important;
}

.assistant-response h3 {
  font-size: 18px;
  /* 1.25rem = 20px */
  font-weight: 400;
  margin: 16px 0 8px;
  /* 1rem = 16px, 0.5rem = 8px */
  color: #575757;
}

.assistant-response h4,
.assistant-response h5,
.assistant-response h6 {
  font-size: 16px;
  /* 1.1rem = 17.6px */
  font-weight: 400;
  margin: 12px 0 8px;
  /* 0.75rem = 12px, 0.5rem = 8px */

}

/* Paragraphs */
.assistant-response p {
  font-size: 16px;
  /* 1rem = 16px */
  margin: 12px 0 !important;
  /* 0.75rem = 12px */
  margin-bottom: 10px !important;

}

/* Unordered Lists */
.assistant-response ul {
  list-style-type: disc;
  margin: 5px 0 20px 0;
  /* 0.75rem = 12px */
  padding-left: 24px;
  /* 1.5rem = 24px */
  margin-bottom: 20px !important;
}

.assistant-response li {
  font-size: 16px;
  /* 1rem = 16px */
  margin-bottom: 8px;
  /* 0.5rem = 8px */
  color: #575757;
}

.assistant-response li p {
  font-size: 16px;
  /* 1rem = 16px */
  margin-bottom: 8px !important;
  /* 0.5rem = 8px */
  color: #575757;
}

/* Ordered Lists */
.assistant-response ol {
  list-style-type: decimal;
  margin: 12px 0;
  /* 0.75rem = 12px */
  padding-left: 24px;
  /* 1.5rem = 24px */
}

.assistant-response ol li {
  font-size: 16px;
  /* 1rem = 16px */
  margin-bottom: 0;
  line-height: 1.5;
  /* 0.5rem = 8px */
  color: #575757;
}

/* Links */
.assistant-response a {
  color: #00b4b4;
  text-decoration: none;
  transition: color 0.2s ease;
}

.assistant-response a:hover {
  color: #00b4b4;
  text-decoration: underline;
}

/* Blockquotes */
.assistant-response blockquote {
  border-left: 4px solid #00b4b4;
  padding: 8px 16px;
  /* 0.5rem = 8px, 1rem = 16px */
  margin: 16px 0;
  /* 1rem = 16px */
  background-color: #f8f9fa;
  font-style: italic;
  color: #575757;
}

/* Code Blocks */
.assistant-response pre,
.assistant-response code {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 14.4px;
  /* 0.9rem = 14.4px */
  background-color: #f8f9fa;
  border-radius: 4px;
}

.assistant-response pre {
  padding: 16px;
  /* 1rem = 16px */
  overflow-x: auto;
  margin: 16px 0;
  /* 1rem = 16px */
}

.assistant-response code {
  padding: 3.2px 6.4px;
  /* 0.2rem = 3.2px, 0.4rem = 6.4px */
}

/*  Add to <style> section  */
.toggle-wrapper {
  user-select: none;
}

.toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
  background: #ccc;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.toggle-switch.checked {
  background: #00b4b4;
}

.toggle-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle-switch.checked .toggle-knob {
  transform: translateX(20px);
}

.sr-only {
  position: absolute;
  left: -9999px;
}

@media screen and (max-width: 991px) {
  .chat-sidebar {
    display: none;
  }
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #00b4b4;
  border-color: #6c757d;
}

.user-question,
.assistant-response,
.box {
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  background: linear-gradient(to bottom, #ffffff, #fbfcfd);
}
.fadetip-enter-active,
.fadetip-leave-active {
  transition: opacity 0.5s ease;
}

.fadetip-enter-from,
.fadetip-leave-to {
  opacity: 0;
}
.prompt-tip-container {
  position: relative;
  min-height: 21px; /* Adjust this to match your tallest expected message */
  margin-top: 10px;
  margin-left: 0;
  font-size: 16px;
  font-weight: normal;
}
.prompt-tip-text {
 background: #fff;
  border-radius: .75rem;
  background: #fff;
  margin-right: auto;
  padding-bottom: .625rem;
  max-width: 80%;
  padding-top: .625rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  text-align: left;
}
</style>